/**
 * Routes accessible without authentication.
 *
 * The single source of truth used by both `frontend/app/src/App.tsx`
 * (which renders the public components) and
 * `frontend/shared/src/hooks/use-account.tsx` (which decides whether
 * to call `loginWithRedirect()` for unauthenticated visitors). Keeping
 * these two consumers in sync historically drifted; collapsing them
 * here makes drift impossible.
 *
 * `PUBLIC_PATHS_EXACT`     — full path equality
 * `PUBLIC_PATH_PREFIXES`   — `pathname.startsWith(...)`
 *
 * The canonical roadmap URL `/roadmap/build_roadmap/:id` is **not**
 * in this list because it does not render a public component; instead
 * App.tsx has a dedicated branch that triggers `login()` with
 * `returnTo: window.location.href` so the user lands back on the
 * roadmap after Auth0.
 */

export const PUBLIC_PATHS_EXACT: readonly string[] = ["/beta_launch"];

export const PUBLIC_PATH_PREFIXES: readonly string[] = [
  "/roadmap/build_roadmap/invite/",
  "/roadmap/build_roadmap/join/",
  "/roadmap/build_roadmap/contribute/",
  "/roadmap/view/",
  "/studio/audio/podcasts/share/",
];

export function isPublicRoute(pathname: string): boolean {
  if (PUBLIC_PATHS_EXACT.includes(pathname)) return true;
  return PUBLIC_PATH_PREFIXES.some((prefix) => pathname.startsWith(prefix));
}
